import { ReactOnRailsRootComponent } from '@common/ReactOnRails';
import SubCatHorizontal from '../components/SubCatHorizontal';

export function SubCategories({ customClass, subcategories, theme }) {
    return (
        <SubCatHorizontal
            customClass={customClass}
            subcategories={subcategories}
            theme={theme}
        />
    );
}

export const SubCategoriesStandalone = ReactOnRailsRootComponent(props => (
    <SubCategories {...props} />),
{ withReduxStore: true });
